import { Base } from "ui/Scripts/source/framework/base";

export interface ICodeTitle {
    code: string;
    title: string;

    getTitle(): string;
    getHash(): string;
}

export class CodeTitle implements ICodeTitle {
    code: string;
    title: string;

    constructor();
    constructor(obj: ICodeTitle);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.title = obj && obj.title || "";
    }

    getTitle(): string {
        return this.title;
    }

    getHash(): string {
        return this.code + "#" + this.title;
    }

    static createCodeTitle(code: string, title: string): ICodeTitle {
        const result = new CodeTitle();
        result.code = code;
        result.title = title;
        return result;
    }

    static getTitleByCode(code: string, items: ICodeTitle[]): string {
        if (Base.isNullOrUndefined(code) || !items || items.length < 1) return "";
        const item = items.find(i => i.code === code);
        return item ? item.title : "";
    }

    static sortCodeTitles(items: ICodeTitle[], column: string, asc: boolean): ICodeTitle[] {
        if (!items && items.length < 2) return items;
        if (column === "title") {
            return items.sort((a: ICodeTitle, b: ICodeTitle) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.title, b.title)); });
        } else {
            return items.sort((a: ICodeTitle, b: ICodeTitle) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        }
    }
}